const API_BASE = process.env.REACT_APP_API_BASE || '';

export function getDeviceId() {
  const key = 'drinkTicketDeviceId';
  let deviceId = localStorage.getItem(key);
  if (!deviceId) {
    deviceId = crypto.randomUUID();
    localStorage.setItem(key, deviceId);
  }
  return deviceId;
}

export async function apiRequest(path, options = {}) {
  const token = localStorage.getItem('drinkTicketAuthToken');
  const response = await fetch(`${API_BASE}/api/${path}`, {
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
      ...(options.headers || {})
    }
  });

  const data = await response.json().catch(() => ({}));

  if (!response.ok) {
    throw new Error(data.error || 'Request failed');
  }

  return data;
}
